// src/components/GamesHub.js
import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { useAppConfig } from "../ConfigContext";
import LoadingSpinner from "./LoadingSpinner";
import GamesTopBar from "./GamesTopBar";
import "../index.css";

const API_BASE = process.env.REACT_APP_API_URL || "";

function SectionCard({ title, subtitle, children }) {
  return (
    <section style={{ marginLeft: -10, marginRight: -10 }}>
      <div
        className="modal_title"
        style={{
  paddingLeft: 0,
  paddingRight: 0,
  boxSizing: "border-box",
  textAlign: "center",
  marginTop: 0,
}}
      >
        {title} ({subtitle})
      </div>

      <div className="modal_body modal_body_2">{children}</div>
    </section>
  );
}

function formatEventDate(value) {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}

function formatDailyCountdown(ms) {
  const total = Math.max(0, Math.floor(Number(ms || 0) / 1000));

  const hours = String(Math.floor(total / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, "0");

  return `${hours}h:${minutes}m`;
}

function DailyRewardsBlock({
  status,
  loading,
  countdownText,
  disabled = false,
  onClaim,
}) {
  const alreadyClaimed = Boolean(status?.checkedInToday);
  const canClaim = Boolean(status) && !loading && !alreadyClaimed && !disabled;

  const rewardIcon =
    status?.rewardKind === "runes" ? "/runes.png" : "/sparks.png";

  return (
    <section style={{ marginLeft: -10, marginRight: -10 }}>
      <div
        className="modal_title"
        style={{
          paddingLeft: 0,
          paddingRight: 0,
          boxSizing: "border-box",
          textAlign: "center",
          marginTop: 5,
        }}
      >
        Daily Rewards
      </div>

      <div className="modal_body modal_body_2">
        <motion.button
          type="button"
          whileTap={canClaim ? { scale: 0.985 } : undefined}
          disabled={!canClaim}
          onClick={canClaim ? onClaim : undefined}
          style={{
            width: "100%",
            minHeight: 92,
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "12px 14px",
            border: "3px solid #cd8f45",
            borderRadius: 8,
            boxSizing: "border-box",
            overflow: "hidden",
            textAlign: "left",
            font: "inherit",
            color: "#fff",
            cursor: canClaim ? "pointer" : "default",
            opacity: loading ? 0.72 : 1,
            backgroundColor: "#492614",
            filter: disabled ? "grayscale(100%)" : "none",
          }}
        >
          {!alreadyClaimed && !loading && !disabled && status && (
            <span
              aria-label="Daily reward available"
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ff0000",
                border: "2px solid #fff",
                boxShadow: `
                  0 0 8px rgba(255,0,0,1),
                  0 0 16px rgba(255,0,0,0.95),
                  0 0 28px rgba(255,0,0,0.85)
                `,
                animation:
                  "gamesLiveDotPulse 0.9s ease-in-out infinite",
              }}
            />
          )}

          <div
            style={{
              flex: "0 0 66px",
              width: 66,
              height: 66,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 8,
              background: "rgba(35,14,5,0.72)",
              boxSizing: "border-box",
            }}
          >
            <img
              src="/v2/menu_2.png"
              alt=""
              draggable={false}
              style={{
                width: 48,
                height: 48,
                objectFit: "contain",
                filter: "drop-shadow(0 4px 4px rgba(0,0,0,0.55))",
              }}
            />
          </div>

          <div
            style={{
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              className="shadow1"
              style={{
                color: "#fff",
                fontSize: 18,
                lineHeight: "20px",
                fontWeight: 600,
              }}
            >
              {loading
                ? "Checking Daily Reward..."
                : status
                  ? `Day ${status.currentDay ?? 1}`
                  : "Daily Reward Unavailable"}
            </div>

            {loading ? (
              <div
                style={{
                  marginTop: 6,
                  color: "rgba(255,255,255,0.72)",
                  fontSize: 13,
                  lineHeight: "16px",
                }}
              >
                Loading your reward status...
              </div>
            ) : !status ? (
              <div
                style={{
                  marginTop: 6,
                  color: "rgba(255,255,255,0.72)",
                  fontSize: 13,
                  lineHeight: "16px",
                }}
              >
                We could not load your daily reward.
              </div>
            ) : alreadyClaimed ? (
              <div
                style={{
                  marginTop: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  color: "#ffd56a",
                  fontSize: 13,
                  fontWeight: 600,
                  lineHeight: "16px",
                  textShadow: "1px 1px #000",
                }}
              >
                <img
                  src="/v2/clock2.png"
                  alt=""
                  style={{
                    width: 28,
                    height: 28,
                    objectFit: "contain",
                  }}
                />

                <span>
                  Next In:<br/>{countdownText || "00h:00m"}
                </span>
              </div>
            ) : (
              <div
                style={{
                  marginTop: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  color: "#ffd56a",
                  fontSize: 15,
                  fontWeight: 600,
                  lineHeight: "18px",
                  textShadow: "1px 1px #000",
                }}
              >
                <img
                  src={rewardIcon}
                  alt=""
                  style={{
                    width: 20,
                    height: 20,
                    objectFit: "contain",
                  }}
                />

                <span>{Number(status.rewardAmount ?? 0)}</span>
              </div>
            )}
          </div>

          <div
            className="game-button-small yellow-button"
            style={{
              flex: "0 0 72px",
              width: 82,
              minHeight: 29,
              lineHeight: "29px",
              margin: 0,
              opacity: canClaim ? 1 : 0.55,
              filter: canClaim ? "none" : "grayscale(100%)",
              cursor: canClaim ? "pointer" : "default",
              pointerEvents: "none",
              textAlign: "center",
            }}
          >
            {loading
              ? "CHECKING"
              : alreadyClaimed
                ? "CLAIMED"
                : status
                  ? "CLAIM"
                  : "OFFLINE"}
          </div>
        </motion.button>
      </div>
    </section>
  );
}

function BattleChallengesBlock({
  loading = false,
  count = 0,
  mineCount = 0,
  onOpen,
}) {
  const openCount = Math.max(0, Number(count || 0));
  const ownCount = Math.max(0, Number(mineCount || 0));

  return (
    <section
      style={{
        marginLeft: -10,
        marginRight: -10,
      }}
    >
      <div
        className="modal_title"
        style={{
          paddingLeft: 0,
          paddingRight: 0,
          boxSizing: "border-box",
          textAlign: "center",
          marginTop: 5,
        }}
      >
        Battle Challenges
      </div>

      <div className="modal_body modal_body_2">
        <motion.button
          type="button"
          whileTap={!loading ? { scale: 0.985 } : undefined}
          disabled={loading}
          onClick={() => {
            if (!loading) {
              onOpen?.();
            }
          }}
          style={{
            width: "100%",
            minHeight: 150,

            position: "relative",

            display: "block",

            padding: 0,
            paddingBottom: 5,

            border: "3px solid rgb(205, 143, 69)",
            borderRadius: 10,

            overflow: "hidden",

            font: "inherit",
            textAlign: "left",

            cursor: loading
              ? "default"
              : "pointer",

            background:
              "linear-gradient(180deg, #3a0c08 0%, #220302 100%)",

            

            opacity: loading
              ? 0.72
              : 1,
          }}
        >
          {/* subtle background effects */}
          <div
            style={{
              position: "absolute",
              inset: 0,

              background:
                "radial-gradient(circle at 15% 50%, rgba(255,174,58,.18), transparent 34%), radial-gradient(circle at 100% 0%, rgba(255,70,30,.13), transparent 35%)",

              pointerEvents: "none",
            }}
          />

          <div
            style={{
              position:
                "relative",

              zIndex: 2,

              display:
                "grid",

              gridTemplateColumns:
                "66px minmax(0, 1fr)",

              gap: 13,

              padding:
                "15px 14px 12px",
            }}
          >


            {/* ICON */}
            <div
              style={{
                width: 66,
                height: 66,

                alignSelf:
                  "start",

                display:
                  "flex",

                alignItems:
                  "center",

                justifyContent:
                  "center",

                borderRadius:
                  12,

                background:
                  "rgba(12,0,0,.55)",

                border:
                  "1px solid rgba(255,197,98,.18)",

                boxShadow:
                  "inset 0 0 18px rgba(0,0,0,.55)",
              }}
            >
              <img
                src="/fightlog.png"
                alt=""
                draggable={false}
                style={{
                  width: 48,
                  height: 48,

                  objectFit:
                    "contain",

                  filter:
                    "drop-shadow(0 5px 4px rgba(0,0,0,.65))",
                }}
              />
            </div>

            {/* CONTENT */}
            <div
              style={{
                minWidth: 0,

                display:
                  "flex",

                flexDirection:
                  "column",

                justifyContent:
                  "center",

                paddingRight: 2,
              }}
            >
              <div
                className="shadow1"
                style={{
                  paddingRight:
                    openCount > 0
                      ? 40
                      : 0,

                  color: "#fff",

                  fontSize: 16,

                  lineHeight:
                    "21px",

                  fontWeight: 600,
                }}
              >
                Challenge Players
              </div>

              <div
                style={{
                  marginTop: 5,

                  maxWidth: 255,

                  color:
                    "rgba(255,255,255,.78)",

                  fontSize: 13,

                  lineHeight:
                    "16px",

                  textShadow:
                    "1px 1px #000",
                }}
              >
                Pick a fighter, set a stake and battle another player for Sparks or Runes.
              </div>

              
            </div>
          </div>

          {/* FOOTER */}
          <div
            style={{
              position:
                "relative",

              zIndex: 2,

              display: "flex",

              alignItems:
                "center",

              justifyContent:
                "space-between",

              gap: 10,
              marginTop: -10,

              padding:
                "8px 12px 11px",
            }}
          >
            <div
              className="game-button-small yellow-button"
              style={{
                flex:
                  "0 0 auto",

                width: "calc(100% - 20px)",

                margin: 0,

                pointerEvents:
                  "none",

                textAlign:
                  "center",
              }}
            >
              {loading
                ? "LOADING..."
                : openCount > 0
                  ? "VIEW"
                  : "CREATE"}
            </div>
          </div>
        </motion.button>
      </div>
    </section>
  );
}

function GameCard({
  title,
  description,
  image,
  enabled = true,
  loading = false,
  badge = "PLAY",
  disabledBadge = "OFFLINE",
  statusText = "",
  endDate = null,
  onClick,
}) {
  const canOpen = enabled && !loading;

  return (
    <motion.button
      type="button"
      whileTap={canOpen ? { scale: 0.97 } : undefined}
      onClick={() => {
        if (!canOpen) return;
        onClick?.();
      }}
      disabled={!canOpen}
      style={{
        width: "100%",
        minWidth: 0,
        border: 0,
        padding: 0,
        background: "transparent",
        font: "inherit",
        textAlign: "center",
        cursor: canOpen ? "pointer" : "not-allowed",
        opacity: loading ? 0.72 : 1,
      }}
    >
      <div
        style={{
          minHeight: 178,
          position: "relative",
          boxSizing: "border-box",
          padding: "12px 8px 10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          overflow: "hidden",
          backgroundImage: 'url("/v2/item.png")',
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          filter: canOpen ? "none" : "grayscale(100%)",
        }}
      >
        {enabled &&
  !loading &&
  title !== "Tap Game" &&
  title !== "Memory Game" &&
  title !== "Fortune Wheel" &&
  title !== "Hidden Objects" &&
  (
    title !== "Tournament" ||
    !endDate ||
    Date.now() < new Date(endDate).getTime()
  ) && (
  <div
    style={{
      position: "absolute",
      top: 14,
      right: 14,
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#ff0000",
      border: "2px solid #ffffff",
      zIndex: 20,
      boxShadow: `
        0 0 8px rgba(255, 0, 0, 1),
        0 0 16px rgba(255, 0, 0, 0.95),
        0 0 28px rgba(255, 0, 0, 0.85)
      `,
      animation: "gamesLiveDotPulse 0.9s ease-in-out infinite",
    }}
  />
)}

        <div
          style={{
            height: 70,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={image}
            alt={title}
            draggable={false}
            style={{
              width: 70,
              height: 70,
              objectFit: "contain",
              userSelect: "none",
              filter: canOpen
                ? "drop-shadow(0 5px 5px rgba(0,0,0,0.55))"
                : "opacity(0.58)",
            }}
          />
        </div>

        <div
          style={{
            width: "100%",
            minHeight: 38,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              color: "#fff",
              fontSize: 17,
              lineHeight: "18px",
              fontWeight: 600,
              textShadow: "1px 1px #000",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              marginTop: 3,
              marginBottom: 3,
            }}
          >
            {title}
          </div>

          <div
            style={{
              color: "rgba(255,255,255,0.72)",
              paddingLeft: 5,
              paddingRight: 5,
              fontSize: 12,
              lineHeight: "13px",
              marginTop: 2,
              minHeight: 26,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              textShadow: "1px 1px #000",
            }}
          >
            {statusText || description}
          </div>
        </div>

        <div
  className="game-button-small yellow-button"
  style={{
    width: "calc(100% - 22px)",
    minHeight: 27,
    lineHeight: "27px",
    marginTop: 8,
    marginBottom: 5,
    marginLeft: 5,
    marginRight: 5,
    opacity: canOpen ? 1 : 0.5,
    filter: canOpen ? "none" : "grayscale(100%)",
    cursor: canOpen ? "pointer" : "not-allowed",
    pointerEvents: "none",
  }}
>
  {loading ? "CHECKING..." : badge}
</div>
      </div>
    </motion.button>
  );
}

export default function GamesHub({
  user,
  onNavigate,
  onOpenProfile,
  hasBattlePass = false,
  battlePassLoading = false,
  onOpenDailyRewards,
  dailyDisabled = false,
  tournamentEnabled = false,
  tournamentBadgeOn = false,
  hasTournament = false,
  tournamentStartDate = null,
  tournamentEndDate = null,
  holidayEnabled = false,
  runeHuntersEnabled = false,
}) {
  const { hiddenSeek } = useAppConfig();

  const hiddenSeekEnabled = Boolean(hiddenSeek?.enabled);
  const tournamentActive = Boolean(
    tournamentEnabled || tournamentBadgeOn || hasTournament
  );

  const [eventLoading, setEventLoading] = useState(true);
  const [eventEnabled, setEventEnabled] = useState(false);

  const [challengeLoading, setChallengeLoading] = useState(true);

const [challengeCount, setChallengeCount] = useState(0);

const [myChallengeCount, setMyChallengeCount] = useState(0);

  const [dailyStatus, setDailyStatus] = useState(null);
  const [dailyStatusLoading, setDailyStatusLoading] = useState(true);
  const [dailyNow, setDailyNow] = useState(Date.now());

  const fetchDailyStatus = async () => {
    const token = localStorage.getItem("token");

    if (!API_BASE || !token || !user?.id || dailyDisabled) {
      setDailyStatus(null);
      setDailyStatusLoading(false);
      return;
    }

    try {
      setDailyStatusLoading(true);

      const response = await fetch(`${API_BASE}/api/daily/status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        console.warn("[GamesHub daily status]", data);
        setDailyStatus(null);
        return;
      }

      setDailyStatus(data);
    } catch (error) {
      console.warn("[GamesHub daily status] failed", error);
      setDailyStatus(null);
    } finally {
      setDailyStatusLoading(false);
    }
  };

  useEffect(() => {
    if (!user?.id || dailyDisabled) {
      setDailyStatus(null);
      setDailyStatusLoading(false);
      return;
    }

    fetchDailyStatus();
  }, [user?.id, dailyDisabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDailyNow(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

    const dailyCountdownText = useMemo(() => {
    if (
      !dailyStatus?.checkedInToday ||
      !dailyStatus?.nextCheckInAt
    ) {
      return null;
    }

    const target = new Date(dailyStatus.nextCheckInAt).getTime();

    if (!Number.isFinite(target)) return null;

    return formatDailyCountdown(target - dailyNow);
  }, [
    dailyStatus?.checkedInToday,
    dailyStatus?.nextCheckInAt,
    dailyNow,
  ]);

    const handleOpenDailyRewards = async () => {
    if (
      dailyDisabled ||
      dailyStatusLoading ||
      !dailyStatus ||
      dailyStatus.checkedInToday
    ) {
      return;
    }

    if (typeof onOpenDailyRewards !== "function") {
      console.warn(
        "GamesHub: onOpenDailyRewards was not provided."
      );
      return;
    }

    const result = await onOpenDailyRewards();

    const opened =
      result === true ||
      result?.ok === true;

    if (opened) {
      await fetchDailyStatus();
    }
  };

  useEffect(() => {
    let cancelled = false;

    async function checkActiveEvent() {
      const token = localStorage.getItem("token");

      if (!API_BASE || !token) {
        if (!cancelled) {
          setEventEnabled(false);
          setEventLoading(false);
        }
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/api/events/current`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json().catch(() => ({}));
        if (cancelled) return;

        setEventEnabled(
          response.ok && Boolean(data?.event || data?.currentEvent)
        );
      } catch (error) {
        if (!cancelled) setEventEnabled(false);
      } finally {
        if (!cancelled) setEventLoading(false);
      }
    }

    checkActiveEvent();

    return () => {
      cancelled = true;
    };
  }, []);


  useEffect(() => {
  let cancelled = false;

  async function loadChallenges() {
    const token =
      localStorage.getItem(
        "token"
      );

    if (
      !API_BASE ||
      !token ||
      !user?.id
    ) {
      if (!cancelled) {
        setChallengeCount(0);
        setMyChallengeCount(0);
        setChallengeLoading(false);
      }

      return;
    }

    try {
      setChallengeLoading(true);

      const headers = {
        Authorization:
          `Bearer ${token}`,

        Accept:
          "application/json",
      };

      const [
        openResponse,
        mineResponse,
      ] =
        await Promise.all([
          fetch(
            `${API_BASE}/api/battle/challenges`,
            {
              method: "GET",
              headers,
            }
          ),

          fetch(
            `${API_BASE}/api/battle/challenges?mine=1`,
            {
              method: "GET",
              headers,
            }
          ),
        ]);

      const [
        openData,
        mineData,
      ] =
        await Promise.all([
          openResponse
            .json()
            .catch(() => ({})),

          mineResponse
            .json()
            .catch(() => ({})),
        ]);

      if (cancelled) {
        return;
      }

      if (openResponse.ok) {
        setChallengeCount(
          Array.isArray(
            openData?.challenges
          )
            ? openData
                .challenges
                .length
            : 0
        );
      } else {
        setChallengeCount(0);

        console.warn(
          "[GamesHub challenges/open]",
          openData
        );
      }

      if (mineResponse.ok) {
        const myOpenChallenges =
          Array.isArray(
            mineData?.challenges
          )
            ? mineData.challenges.filter(
                challenge =>
                  challenge?.status ===
                  "open"
              )
            : [];

        setMyChallengeCount(
          myOpenChallenges.length
        );

      } else {
        setMyChallengeCount(0);

        console.warn(
          "[GamesHub challenges/mine]",
          mineData
        );
      }

    } catch (error) {
      if (!cancelled) {
        console.warn(
          "[GamesHub challenges] failed",
          error
        );

        setChallengeCount(0);
        setMyChallengeCount(0);
      }

    } finally {
      if (!cancelled) {
        setChallengeLoading(false);
      }
    }
  }

  loadChallenges();

  return () => {
    cancelled = true;
  };

}, [user?.id]);


  const tournamentStatus = useMemo(() => {
    if (!tournamentActive) return "No tournament is currently active.";

    const start = formatEventDate(tournamentStartDate);
    const end = formatEventDate(tournamentEndDate);

    if (start && end) return `${start} – ${end}`;
    if (end) return `Available until ${end}`;
    if (start) return `Started ${start}`;
    return "Tournament available now.";
  }, [tournamentActive, tournamentStartDate, tournamentEndDate]);

  const liveGames = [
    {
      key: "holiday",
      title: "Holiday Event",
      description: "Limited-time seasonal game and rewards.",
      image: "/icon_holiday.png?v1",
      enabled: Boolean(holidayEnabled),
      disabledBadge: "NOT ACTIVE",
      statusText: holidayEnabled
        ? "Holiday event available now."
        : "No holiday event is currently active.",
      route: "holidayevent",
    },
    {
      key: "tournament",
      title: "Tournament",
      description: "Compete against other players for the top rank.",
      image: tournamentActive
        ? "/icon_tournament_on.png?v1"
        : "/icon_tournament_off.png?v2",
      enabled: tournamentActive,
      endDate: tournamentEndDate,
      disabledBadge: "NOT ACTIVE",
      statusText: tournamentStatus,
      route: "tournaments",
    },
    {
      key: "event",
      title: "Special Event",
      description: "Complete missions and collect exclusive rewards.",
      image: "/event_icon.png",
      enabled: eventEnabled,
      loading: eventLoading,
      disabledBadge: "NOT ACTIVE",
      statusText: eventEnabled
        ? "A special event is available now."
        : "No special event is currently active.",
      route: "events",
    },
    {
      key: "rune-hunters",
      title: "Rune Hunters",
      description: "Keep your streak alive and hunt for runes.",
      image: "/icon_rune.png?v1",
      enabled: Boolean(runeHuntersEnabled),
      disabledBadge: "NOT ACTIVE",
      statusText: runeHuntersEnabled
        ? "Rune Hunters is available now."
        : "Rune Hunters is not currently active.",
      route: "streakevent",
    },
  ];

  const permanentGames = [
   {
    key: "tap-game",
    title: "Tap Game",
    description: "Tap, earn rewards, and keep progressing.",
    image: "/tapicon.png?v1",
    enabled: true,
    route: "home",
  },
    {
      key: "memory",
      title: "Memory Game",
      description: "Match the cards and test your memory.",
      image: "/memory_big.png?v1",
      enabled: true,
      route: "memoryGame",
    },
    {
      key: "fortune",
      title: "Fortune Wheel",
      description: "Spin the wheel and collect your prize.",
      image: "/fortunebt.png?v1",
      enabled: true,
      route: "fortuneWheel",
    },
    {
      key: "hidden-seek",
      title: "Hidden Objects",
      description: "Find every hidden object before time runs out.",
      image: "/icon_hidden.png?v1",
      enabled: hiddenSeekEnabled,
      disabledBadge: "NOT ACTIVE",
      statusText: hiddenSeekEnabled
        ? "Search and uncover every hidden object."
        : "Hidden Objects is not currently active.",
      route: "hiddenSeek",
    },
  ];

  const sortedLiveGames = [...liveGames].sort(
  (a, b) => Number(b.enabled) - Number(a.enabled)
);

  const availableCount = [...liveGames, ...permanentGames].filter(
    (game) => game.enabled
  ).length;

  const renderGame = (game, showDot = false) => {
  const { key, ...restProps } = game;

  return (
    <GameCard
      key={key}
      {...restProps}
      onClick={() => onNavigate?.(game.route)}
    />
  );
};

const hubLoading = eventLoading || dailyStatusLoading;

if (hubLoading) {
  return (
    <div
      className="shop-container"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingSpinner text="Loading Games" size={64} />
    </div>
  );
}

return (
  <div className="shop-container" style={{ paddingTop: 10, paddingBottom: 0 }}>
    <div style={{ width: "100%", maxWidth: 450, margin: "0 auto" }}>
      <GamesTopBar
        user={user}
         hasBattlePass={hasBattlePass}
        battlePassLoading={battlePassLoading}
        onNavigate={onNavigate}
        onOpenProfile={onOpenProfile}
      />
        
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
  {!dailyDisabled && (
  <DailyRewardsBlock
    status={dailyStatus}
    loading={dailyStatusLoading}
    countdownText={dailyCountdownText}
    disabled={dailyDisabled}
    onClaim={handleOpenDailyRewards}
  />
)}


<BattleChallengesBlock
  loading={challengeLoading}

  count={challengeCount}

  mineCount={myChallengeCount}

  onOpen={() =>
    onNavigate?.(
      "challenges"
    )
  }
/>


<SectionCard
  title="Live Game Events"
  subtitle={liveGames.filter((g) => g.enabled).length}
>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: 8,
                }}
              >
                {sortedLiveGames.map(renderGame)}
              </div>
            </SectionCard>

            <SectionCard title="Explore More Games" subtitle={permanentGames.filter((g) => g.enabled).length}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: 8,
                }}
              >
                {permanentGames.map(renderGame)}
              </div>
            </SectionCard>
          </div>
      </div>
    </div>
  );
}
